document.addEventListener('DOMContentLoaded', function() {
  // Function to update cart count dynamically
  function updateCartCount() {
    console.log('Updating cart count...');
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(function(response) {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    })
    .then(function(cart) {
      var cartCount = cart.item_count;
      console.log('Cart count:', cartCount);
      var cartBubble = document.querySelector('.Header__CartCount');
      if (cartBubble) {
        cartBubble.textContent = cartCount;
        cartBubble.classList.toggle('is-visible', cartCount > 0);
      } else {
        console.error('Cart bubble element (.Header__CartCount) not found');
      }
    })
    .catch(function(error) {
      console.error('Error fetching cart:', error);
    });
  }

  // Function to prevent cart drawer from opening
  function preventCartDrawerOpen() {
    var cartDrawer = document.querySelector('.CartDrawer');
    if (cartDrawer) {
      cartDrawer.classList.remove('is-open');
      cartDrawer.style.display = 'none';
    } else {
      console.error('Cart drawer element (.CartDrawer) not found');
    }
  }

  // Initial cart count update on page load
  updateCartCount();

  // Listen for Prestige-specific cart update events
  document.addEventListener('cart:refresh', function() {
    console.log('cart:refresh event triggered');
    updateCartCount();
    preventCartDrawerOpen();
  });

  // Listen for add-to-cart form submissions
  document.addEventListener('submit', function(event) {
    if (event.target.matches('.ProductForm__AddToCart, .product-form')) {
      console.log('Add-to-cart form submitted');
      setTimeout(function() {
        updateCartCount();
        preventCartDrawerOpen();
      }, 500);
    }
  });

  // Listen for remove item clicks in the cart drawer
  document.addEventListener('click', function(event) {
    if (event.target.closest('.CartItem__Remove, .cart-item__remove')) {
      console.log('Remove item clicked');
      setTimeout(updateCartCount, 500);
    }
  });

  // Handle "Buy Now" form submissions
  var buyNowForms = document.querySelectorAll('.buy-now-form');
  for (var i = 0; i < buyNowForms.length; i++) {
    buyNowForms[i].addEventListener('submit', function(e) {
      e.preventDefault();
      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(this)
      })
      .then(function() {
        window.location.href = '/checkout';
      });
    });
  }

  // Fallback: Poll cart every 1.5 seconds (only if events fail)
  setInterval(updateCartCount, 1500);
});